export const DEFAULT_BELIEFS_VALUES = {
  title: 'Our Values',
  items: [
    {
      label: 'The Holy Spirit:',
      text: 'We hold fast to the empowering presence of the Holy Spirit, who marks us as God’s people and works miraculously in our lives. Through His presence, we find purpose, strength, and divine guidance.',
    },
    {
      label: 'God’s Word:',
      text: 'We are a “Word-centered” church, embracing the transformative power of Scripture to shape every aspect of our worship, teachings, and ministry. The Bible serves as our compass, directing us toward a life that reflects God’s truth and love.',
    },
    {
      label: 'Living Our Values:',
      text: 'These principles inspire us to foster a community grounded in love, service, and hope—reflecting God’s glory in all that we do and inviting others to experience His grace.',
    },
  ],
};

export function resolveBeliefsValues(getContent) {
  const storedItems = getContent('beliefs.values.items', null);
  const title = getContent('beliefs.values.title', DEFAULT_BELIEFS_VALUES.title);

  if (Array.isArray(storedItems) && storedItems.length) {
    return {
      title,
      items: storedItems.map((item, index) => ({
        label: item.label || DEFAULT_BELIEFS_VALUES.items[index]?.label || '',
        text: item.text || DEFAULT_BELIEFS_VALUES.items[index]?.text || '',
      })),
    };
  }

  return {
    title,
    items: DEFAULT_BELIEFS_VALUES.items.map((item, index) => ({
      label: getContent(`beliefs.values.${index}.label`, item.label),
      text: getContent(`beliefs.values.${index}.text`, item.text),
    })),
  };
}
